import { lazy } from 'react';
import type { AppRoute } from 'src/shared/routes';

const ServicesPage = lazy(() => import('./ServicesPage'));

export const servicesRoutes: AppRoute[] = [
  { path: '/servicios', name: 'Servicios', element: ServicesPage },
];
